(jQuery)(function($) {
    // Select all FAQ items
    $('.wp-block-yoast-faq-block .schema-faq-section').each(function() {
        var $section = $(this);
        var $answer = $section.find('.schema-faq-answer');

        // Initially hide the answer
        $answer.hide();

        // Toggle answer visibility on question click
        $section.on('click', function() {
            $answer.slideToggle(300);
            $section.toggleClass('open');
        });
    });
});